<template>
    <DashView>
        <div class="container-fluid pt-4 px-4">
            <div class="row g-4">
                <!-- Column -->
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-body">
                            <h3 class="text-center underline">Enrégistrer Patient&nbsp;<a href="/patient-all"><i class="fa fa-file" title="Lister Patient"></i></a></h3>
                            <div class="row" v-if="validationErrors.length>0">
                                  <div class="offset-2 col-md-8 col-sm-12 alert alert-danger alert-md text-danger mx-auto">
                                      <ul v-if="validationErrors.length>0" class="list-unstyled text-center mx-auto">
                                          <li v-for="(error,key) in validationErrors" :key="key" class="p-2"><div class="">{{error}}</div></li>
                                      </ul>
                                  </div>
                              </div>
                            <form @submit.prevent="registerPatient" ref="fpatient">
                              <div class="col-sm-12">
                                  <div class="row">
                                      <div class="col-sm-4 form-group">
                                          <label for="usname">Nom <span class="required">*</span></label>
                                          <input type="text"  title="Ajouter Nom" v-model="form.nom" placeholder="Nom" @keyup="validateName" required id="usname" class="form-control">
                                          <p v-if="alertName" class="alert"> {{ alertName }} </p>
                                      </div>
                                      <div class="col-sm-4 form-group">
                                          <label for="usfname">Prénom <span class="required">*</span></label>
                                          <input type="text"  title="Ajouter Prénom" v-model="form.prenom" required placeholder="Prénom" name="usfname" @keyup="validateFirstName" class="form-control">
                                          <p v-if="alertFirstName" class="alert"> {{ alertFirstName }} </p>
                                      </div>
                                      <div class="col-sm-4 form-group">
                                          <label for="ussexe">Sexe <span class="required">*</span></label>
                                          <select class="form-control custom-select text-center" v-model="form.sexe" required>
                                              <option value="" disabled>--Choisir--</option>
                                              <option value="1">Masculin</option>
                                              <option value="0">Féminin</option>
                                              <option value="2">Autre</option>
                                          </select>
                                      </div>                                      
                                  </div> 
                                  <div class="row">
                                    <div class="col-sm-4 form-group">
                                          <label for="usgsanguin">Groupe Sanguin</label>
                                          <select v-model="form.gsanguin" class="form-control" id="usgsanguin">
                                                <option value="" disabled>-- Selectionner Groupe Sanguin --</option>
                                                <option value="O+">O+</option>
                                                <option value="O-">O-</option>
                                                <option value="A+">A+</option>
                                                <option value="A-">A-</option>
                                                <option value="B+">B+</option>
                                                <option value="B-">B-</option>
                                                <option value="AB+">AB+</option>
                                                <option value="AB-">AB-</option>
                                            </select>
                                      </div>
                                      <div class="col-sm-4 form-group">
                                          <label for="usadresse">Poids (kg)</label>
                                          <input type="text" id="usadresse" v-model="form.poids" title="Ajouter Poids" class="form-control">
                                        </div>
                                        <div class="col-sm-4 form-group">
                                            <label for="usmail">Taille (cm)</label>
                                            <input type="text" id="usadresse" v-model="form.taille" title="Ajouter Taille" class="form-control" >
                                              <!-- <p v-if="alertLieu" class="alert"> {{ alertLieu }} </p> -->
                                      </div>                                      
                                  </div>				
                                  <div class="row">
                                    <div class="col-sm-4 form-group">
                                          <label for="ustelephone">Téléphone<span class="required">*</span></label>
                                          <input type="number" v-model="form.phone"  title="Format(8 Chiffres):42003583" @keyup="validatePhone" placeholder="42003583"  name="ustelephone" id="ustelephone" class="form-control" autocomplete="off" required>
                                          <p v-if="alertPhone" class="alert"> {{ alertPhone }} </p>
                                      </div>
                                      <div class="col-sm-4 form-group">
                                          <label for="usadresse">Email</label>
                                          <input type="text" id="usadresse" v-model="form.email" title="Ajouter Adresse" class="form-control" autocomplete="off">
                                      </div>
                                      <div class="col-sm-4 form-group">
                                          <label for="usmail">Lieu Naissance<span class="required">*</span></label>
                                              <input type="text" v-model="form.lieu_naisssance" title="Ajouter Lieu Naissance" @keyup="validateLieu" placeholder="Cap-Haitien" name="lieunaiss" id="lieunaiss" class="form-control" required>
                                              <p v-if="alertLieu" class="alert"> {{ alertLieu }} </p>
                                      </div>                                      
                                  </div>				
                                  <div class="row"> 
                                        <div class="col-sm-4 form-group">
                                          <label for="usmail">Date Naissance<span class="required">*</span></label>
                                              <input type="date" v-model="form.date_naissance" title="Ajouter Date Naissance" placeholder="01/01/1804" name="usnaiss" id="usnaiss" class="form-control" required>
                                      </div>                                                              
                                      <div class="col-sm-4 form-group">
                                          <label for="usmail">Profession</label>
                                              <input type="text" v-model="form.profession" title="Ajouter Profession" placeholder="Informaticien" @keyup="validateProfession" name="usprof" id="usprof" class="form-control">
                                      </div>                                                               
                                      <div class="col-sm-4 form-group">
                                          <label for="usmail">Travail</label>
                                              <input type="text" v-model="form.travail" title="Tu fais quel travail?" placeholder="Informatique" name="ustrav" id="ustrav" class="form-control">
                                      </div>                                                               
                                  </div>				
                                  <div class="row">                                                             
                                      <div class="col-sm-4 form-group">
                                          <label for="persRef">Personne Ref.</label>
                                          <input  type="text" v-model="form.personne_ref" title="Entrer Personne Ref." autocomplete="off" class="form-control">
                                      </div>                                                                
                                      <div class="col-sm-4 form-group">
                                          <label for="npersRef">Téléphone Personne Ref.</label>
                                          <input  type="text" v-model="form.num_pers_ref" title="Veuillez entrer nombre!" autocomplete="off" class="form-control">
                                      </div>                                                              
                                      <div class="col-sm-4 form-group">
                                          <label for="npersRef">Numéro Carte Patient (Fiche)</label>
                                          <input  type="text" v-model="form.numero_carte_patient" title="Veuillez entrer nombre!" autocomplete="off" class="form-control">
                                      </div> <br>                                     
                                                                                                  
                                  </div> <br>
                                  <div>
                                    <div class="hrdivider">
                                        <hr/>
                                        <span>Adresse</span>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-4 form-group">
                                          <label for="departement_patient">Département<span class="required">*</span></label>
                                          <select class="form-control custom-select text-center" id="departement_patient" required v-model="form.departement" @change="getCommunesforDepartement">
                                              <option value="" disabled>--Département--</option>
                                              <template v-if="departements.length > 0">
                                              <option v-for="(departement,key) in departements" :key="key" :value="departement.id">{{ departement.departement }}</option>
                                              </template>
                                              <template v-else>
                                              <option value="">Aucun Département trouvé</option>
                                              </template>
                                          </select>
                                        </div>                                                        
                                        <div class="col-sm-4 form-group">
                                          <label for="commune_patient">Communes<span class="required">*</span></label>
                                          <select class="form-control custom-select text-center" id="commune_patient" required v-model="form.commune" >
                                              <option value="" disabled>--Communes--</option>
                                              <template v-if="communes.length > 0">
                                              <option v-for="(commune,key) in communes" :key="key" :value="commune.id">{{ commune.commune }}</option>
                                              </template>
                                              <template v-else>
                                              <option value="">Aucune Commune trouvé</option>
                                              </template>
                                          </select>
                                        </div>
                                      <div class="col-sm-4 form-group">
                                          <label for="adresse_patient">Adresse<span class="required">*</span></label>
                                          <input  type="text" id="adresse_patient" v-model="form.adresse" title="Entrer Adresse Patient!" autocomplete="off" class="form-control" required>
                                      </div>                                                       
                                  </div>
                                    </div>
                                    <div>
                                        <label>
                                            <input type="checkbox" :value="showAssureur" v-model="showAssureur">
                                            Je suis assuré
                                        </label>
                                    </div>
                                  <br>
                                  <div v-if="showAssureur">
                                    <div class="hrdivider">
                                        <hr/>
                                        <span>Assureur</span>                                        
                                    </div>
                                    <div class="row">                                                             
                                      <div class="col-sm-4 form-group">
                                          <label for="persRef">Numéro Police</label>
                                          <input  type="text" v-model="assureur.numero_police" title="Entrer Personne Ref." @blur="getCodePolice" @keypress="emptyAssureur" @keydown="emptyAssureur" autocomplete="off" class="form-control">
                                      </div>                                                                
                                      <div class="col-sm-4 form-group">
                                          <label for="npersRef">Nom</label>
                                          <input  type="text" :readonly="findAss" v-model="assureur.nom" title="Veuillez entrer le nom" autocomplete="off" class="form-control">
                                      </div>
                                      <div class="col-sm-4 form-group">
                                          <label for="npersRef">Prénom</label>
                                          <input  type="text" :readonly="findAss" v-model="assureur.prenom" title="Veuillez entrer nombre!" autocomplete="off" class="form-control">
                                      </div>                                                         
                                    </div>
                                    <div class="row"> 
                                        <div class="col-sm-4 form-group">
                                            <label for="usmail">Date Naissance<span class="required">*</span></label>
                                                <input type="date" :readonly="findAss" v-model="assureur.naissance" title="Ajouter Date Naissance" placeholder="01/01/1804" name="usnaiss" id="usnaiss" class="form-control">
                                        </div>                                                             
                                        <div class="col-sm-4 form-group">
                                            <label for="ussexe">Sexe <span class="required">*</span></label>
                                            <select class="form-control custom-select text-center" :disabled="findAss" v-model="assureur.sexe">
                                                <option value="">--Choisir--</option>
                                                <option value="1">Masculin</option>
                                                <option value="0">Feminin</option>
                                                <option value="2">Autre</option>
                                            </select>
                                        </div>    
                                        <div class="col-sm-4 form-group">
                                            <label for="usrole">Assurance<span class="required">*</span></label>
                                            <select class="form-control custom-select text-center" id="usrole" :disabled="findAss" v-model="assureur.assurance" >
                                                <option value="">--Assurances--</option>
                                                <template v-if="assurances.length > 0">
                                                <option v-for="(assurance,key) in assurances" :key="key" :value="assurance.assurance_id">{{ assurance.assurance }}</option>
                                                </template>
                                                <template v-else>
                                                <option value="">Aucune Assurance trouvée</option>
                                                </template>
                                            </select>
                                        </div>                                                                                            
                                    </div>
                                  <div class="row">
                                    <div class="col-sm-4 form-group">
                                          <label for="persRef">Numéro Assurance</label>
                                          <input  type="text" :readonly="findAss" v-model="assureur.numero_assurance" title="Entrer Personne Ref." autocomplete="off" class="form-control">
                                      </div>                                                              
                                        <div class="col-sm-4 form-group">
                                          <label for="persRef">Téléphone</label>
                                          <input  type="number" :readonly="findAss" v-model="assureur.telephone" title="Entrer Téléphone" autocomplete="off" class="form-control">
                                      </div>
                                        <div class="col-sm-4 form-group">
                                          <label for="persRef">Adresse</label>
                                          <input  type="text" :readonly="findAss" v-model="assureur.adresse" title="Entrer Adresse" autocomplete="off" class="form-control">
                                      </div>
                                                                                          
                                  </div>  
                                  <div class="row">
                                    <div class="col-sm-4 form-group">
                                          <label for="ussexe">Couverture Dépendant<span class="required">*</span></label>
                                          <select class="form-control custom-select text-center" :disabled="findAss" v-model="assureur.couverture_dependant">
                                              <option value="">--Choisir--</option>
                                              <option value="1">Oui</option>
                                              <option value="0">Non</option>
                                          </select>
                                      </div> 
                                  </div>  
                                </div>
                                  
                                  <div class="row mb-5 pt-2 pb-2">
                                    <div class="pt-2">
                                        <button type="submit" class="btn btn-block btn-lg col-12" style="background:#00C853; color: #fff;">Enrégistrer</button>
                                    </div>
                                </div>
                                <br> <br>	
                              </div>
                          </form> 
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </DashView>
</template>
<script>
 import axios from 'axios'
    const base_url=process.env.VUE_APP_API_URL;
import DashView from "@/components/DashView.vue"
export default {
    name:"PatientRegister",
    components:{
        DashView
    },
    data(){
        return{
            success_msg:'',
            showAssureur:false,
            assurances:[],
            departements:[],
            communes:[],
            findAss:false,
            validationErrors:[],
            accessToken:JSON.parse(localStorage.getItem('user_zgh')).token ?? '',
            form :{
                nom: '',
                prenom: '',
                sexe:1,
                phone:'',
                email:'',
                lieu_naisssance:'',
                date_naissance:'',
                profession:'',
                travail:'',
                personne_ref:'',
                num_pers_ref:'',
                numero_carte_patient:'',
                departement:'',
                commune:'',
                adresse:'',
                gsanguin:'',
                poids:'',
                taille:''
            },
            alertLieu: '',
            alertName:'',
            alertFirstName:'',
            alertPhone:'',
            regexNonVide:/^\s*$/,
            roles:[],
            assureur:{
                nom:'',
                prenom:'',
                sexe:1,
                naissance:'',
                numero_assurance:'',
                assurance:'',
                numero_police:'',
                couverture_dependant:'',
                telephone:'',
                adresse:'',
            }
        }
    },
    methods:{
        trimSpaces(str) {
            return str.replace(/^\s+|\s+$/g, '');
        },
        redirectTo(path) {
            this.$router.push(path);
            setTimeout(function() {
                location.reload();
            }, 1);
        },
        validateName() {
            const regexName = /^[a-zA-Z\s\-]+$/;
            if (!regexName.test(this.form.nom)) {
                this.alertName = 'Veuillez saisir un nom valide!';
            } else {
                this.alertName = '';
            }
            if (this.regexNonVide.test(this.form.nom)) {
                this.alertName = 'Veuillez remplir ce champ!';
            }else {
                this.alertName = '';
            }
        },
        validateFirstName(){
            const regexFName = /^[a-zA-Z\s\-]+$/;
            if (!regexFName.test(this.form.prenom)) {
                this.alertFirstName = 'Veuillez saisir un prenom valide!';
            } else {
                this.alertFirstName = '';
            }
            if (this.regexNonVide.test(this.form.prenom)) {
                this.alertFirstName = 'Veuillez remplir ce champ!';
            }
        },
        validateLieu(){
            const regexFLieu = /^[a-zA-Z0-9 -]+$/;
            if (!regexFLieu.test(this.form.lieu_naisssance)) {
                this.alertLieu = 'Veuillez saisir un lieu valide!';
            } else {
                this.alertLieu = '';
            }
            if (this.regexNonVide.test(this.form.lieu_naisssance)) {
                this.alertLieu = 'Veuillez remplir ce champ!';
            }
        },
        validateAdresse(){
            const regexFAdresse = /^[a-zA-Z0-9 -#,]+$/;
            if (!regexFAdresse.test(this.form.adresse)) {
                this.alertAdresse = 'Veuillez saisir une adresse valide!';
            } else {
                this.alertAdresse = '';
            }
            if (this.regexNonVide.test(this.form.adresse)) {
                this.alertAdresse = 'Veuillez remplir ce champ!';
            }
        },
        validatePhone() {
            //!Seulement 8 chiffres commencant par 3 ou 4 ou 5
            const regexPhone = /^[345]\d{7}$/;
            if (!regexPhone.test(this.form.phone)) {
                this.alertPhone = 'Saisir un numero valide : 8 chiffres, ex :42003583)';
            } else {
                this.alertPhone = '';
            }
            if (this.regexNonVide.test(this.form.phone)) {
                this.alertPhone = 'Veuillez remplir ce champ!';
            }
        },
        registerPatient(){
            console.log('ok');
            console.log(this.form);
            
            const control = !!(this.form.nom && this.form.prenom && this.form.sexe && this.form.phone && this.form.lieu_naisssance && this.form.date_naissance); 
            // console.log(control);
            // return false;
            if(control){
                    let $info_assureur=[];
                    if(this.showAssureur){
                        $info_assureur={
                            ass_nom:this.assureur.nom,
                            ass_prenom:this.assureur.prenom,
                            ass_sexe:this.assureur.sexe,
                            ass_naissance:this.assureur.naissance,
                            ass_numero_assurance:this.assureur.numero_assurance,
                            ass_assurance:this.assureur.assurance,
                            ass_numero_police:this.assureur.numero_police,
                            ass_couverture_dependant:this.assureur.couverture_dependant,
                            ass_telephone:this.assureur.telephone,
                            ass_adresse:this.assureur.adresse,
                            already:this.findAss,
                        }
                    }
                    const $data ={
                        patient:{
                            nom : this.form.nom,
                            prenom : this.form.prenom,
                            email : this.form.email,
                            sexe:this.form.sexe,
                            phone: this.form.phone,
                            lieu_naissance:this.form.lieu_naisssance,
                            date_naissance:this.form.date_naissance,
                            profession:this.form.profession,
                            travail:this.form.travail,
                            adresse:this.form.adresse,
                            departement:this.form.departement,
                            commune:this.form.commune,
                            personne_ref:this.form.personne_ref,
                            numero_pers_ref:this.form.num_pers_ref,
                            numero_carte_patient : this.form.numero_carte_patient,
                            isAssure:this.showAssureur,
                            groupe_sanguin : this.form.gsanguin,
                            poids: this.form.poids,
                            taille: this.form.taille,
                        },
                        assureur:$info_assureur
                    };
                console.log($data);
                // return false;
                // this.$refs.fpatient.reset();
                axios.post(`${base_url}/addPatient`,$data,{
                    headers:{
                        Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
                .then((response)=>{
                    console.log(response.data);
                    if(response.status==201){
                        this.success_msg = `Utilisateur ajouté avec success!`;
                        let self = this;
                        setTimeout(function() {
                                self.$router.push('/patient-all');
                            //   location.reload();
                            },2000);
                    }
                    else{
                        console.log('Erreur!!!');
                    }
                })
                .catch((error)=>{
                    // console.log(error);
                    if (error?.response?.status === 401) {
                            const error_msg = error.response.data.errors;
                            console.log(error_msg);
                            this.displayValidationErrors(error.response.data.errors);                       
                    } 
                    else if(error?.response?.status === 403){
                        console.log('NO access');
                        $('#openModalNoAccess').trigger('click');
                    }
                    else {
                    // Gérer d'autres erreurs ici
                    console.log('Autre erreur:', error);
                    }
                })
            }
        
        },
        displayValidationErrors(errors) {
            this.validationErrors = [];

            // Parcourir les erreurs et les ajouter au tableau
            Object.keys(errors).forEach(field => {
                this.validationErrors.push(errors[field][0]);
            });

            // Définir un délai de 5 secondes avant de vider les erreurs
            setTimeout(() => {
                this.clearValidationErrors();
            }, 5000);

        },
        clearValidationErrors() {
            this.validationErrors = [];
        },
        getAssurances(){
            axios.get(`${base_url}/assurances_for_add_assureur`,{
                    headers:{
                            Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
              .then((response)=>{
                  //console.log(response.data);
                  if(response.data){
                      this.assurances = response.data;
                  }                  
                  
              })
              .catch((error)=>{
                console.log(error?.response?.status);
                if(error?.response?.status === 403){
                        console.log('NO access');
                        $('#openModalNoAccess').trigger('click');
                }
                else {
                // Gérer d'autres erreurs ici
                console.log('Une erreur est survenue!');
                console.log('Autre erreur:', error);
                }
              });
        },
        getCodePolice(){
            this.findAss=false;
            if(this.assureur.numero_police){
                console.log(this.assureur.numero_police);
                // return false;
                axios.get(`${base_url}/getInfoWithNumeroPolice?numero_police=${this.assureur.numero_police}`,{
                        headers:{
                                Accept:'application/json',
                            'Content-Type':'application/json;charset=UTF-8',
                            Authorization:`Bearer ${this.accessToken}`
                        }
                    })
                .then((response)=>{
                    
                    console.log('Data Numero Police');
                    console.log(response.data);
                    if(response.data?.id){
                        this.findAss=true;
                            this.assureur.nom=response.data?.nom;
                            this.assureur.prenom=response.data?.prenom;
                            this.assureur.sexe=response.data?.sexe;
                            this.assureur.naissance=response.data?.naissance;
                            this.assureur.numero_assurance=response.data?.numero_assurre;
                            this.assureur.assurance=response.data?.assurrance_id
                            this.assureur.numero_police=response.data?.numero_police;
                            this.assureur.couverture_dependant=response.data?.couverture_dependant;
                            this.assureur.telephone=response.data?.telephone;
                            this.assureur.adresse=response.data?.adresse;
                    }                  
                    
                })
                .catch((error)=>{
                    console.log(error?.response?.status);
                    if(error?.response?.status === 403){
                            console.log('NO access');
                            $('#openModalNoAccess').trigger('click');
                    }
                    else {
                    // Gérer d'autres erreurs ici
                    console.log('Une erreur est survenue!');
                    console.log('Autre erreur:', error);
                    }
                });
            }
        },
        emptyAssureur(){
            this.findAss=false;
            this.assureur.nom='';
            this.assureur.prenom='';
            this.assureur.sexe='';
            this.assureur.naissance='';
            this.assureur.numero_assurance='';
            this.assureur.assurance='';
            this.assureur.couverture_dependant='';
            this.assureur.telephone='';
            this.assureur.adresse='';
        },
        getCommunesforDepartement(){
            this.form.commune='';
            this.communes=[];
            if(this.form.departement){
                axios.get(`${base_url}/geo/communes?departement=${this.form.departement}`,{
                    headers:{
                            Accept:'application/json',
                            'Content-Type':'application/json;charset=UTF-8',
                            Authorization:`Bearer ${this.accessToken}`
                        }
                    })
                    .then((response)=>{
                        console.log(response?.data);
                        if(response?.status==200){
                            // console.log(response?.data);
                            if(response?.data?.length>0){
                                this.communes = response.data
                                .filter(element=>element.departement_id==this.form.departement);
                            }
                        }                
                    })
                    .catch((error)=>{
                        console.log('Une erreur est survenue!');
                        console.error(error);
                    });
            }
        }
    },
    created(){
        axios.get(`${base_url}/geo/departements`,{
                headers:{
                        Accept:'application/json',
                        'Content-Type':'application/json;charset=UTF-8',
                        Authorization:`Bearer ${this.accessToken}`
                    }
                })
                .then((response)=>{
                    console.log(response?.data);
                    if(response?.status==200){
                        if(response?.data?.length>0){
                            this.departements = response.data;
                        }
                    }                
                })
                .catch((error)=>{
                    console.log('Une erreur est survenue!');
                    console.error(error);
                });
    },
    mounted(){
        this.getAssurances();
    }
}
</script>
<style scoped>
    .alert{
      color:red;
    }
    @media (max-width: 600px) {
        form {
            height: 80vh; /* Utilise 80% de la hauteur de la vue pour la forme */
            overflow-x: auto; /* Ajoute une barre de défilement horizontale si nécessaire */
            overflow-y: auto; /* Ajoute une barre de défilement verticale si nécessaire */
        }
        .form-group {
            margin-bottom: 15px;
        }
        .btn-submit {
            width: 100%;
            display: block;
        }
        .pt-2 {
            padding-top: 15px;
        }
    }
.hrdivider {
  position: relative;
  margin-bottom: 20px;
  width: 100%;
  text-align: center;
}

.hrdivider hr {
  border: none;
  border-top: 4px solid #00C853;
  margin: 0;
}

.hrdivider span {
  position: absolute;
  top: -11px;
  background: #fff;
  padding: 0 20px;
  font-weight: bold;
  font-size: 19px;
}

</style>

